import Vue from "vue"

export default ({ query, enablePreview }) => {
  if (query._storyblok) {
    enablePreview()

    // Workaround necessary for the Storyblok preview highlighting
    const editableDirective = Vue.options.directives.editable
    editableDirective.update = (...args) => {
      editableDirective.bind(...args)
    }
  }
}
